// @flow

import React, { Component } from 'react'

import CheckMark from './feedback.svg'

import './style.scss'

type Props = {}

type State = {
  done: boolean,
  processing: boolean,
}

export default class NewsletterInput extends Component<Props, State> {
  static defaultProps = {
    small: false,
    white: false,
  }

  state = {
    email: '',
    processing: false,
    done: false,
  }

  onSubmit = (e: SyntheticEvent<*>) => {
    e.preventDefault()

    this.setState({
      processing: true,
    })
    e.currentTarget.submit()
  }

  urlChange = () => {
    if (this.state.processing) {
      this.setState({
        done: true,
        processing: false,
      })
    }
  }

  render() {
    if (this.state.done) {
      return (
        <div className="newsletter-input done">
          <img src={CheckMark} alt="" />
          <span>Yay! {"You're"} subscribed.</span>
        </div>
      )
    }

    const theId = `newsletter-input`
    return (
      <div className="newsletter-input">
        <form
          action="//mainframe.us15.list-manage.com/subscribe/post?u=8c5d4946109674bf37caa2fc8&amp;id=767c5e7011"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          target={theId}
          onSubmit={this.onSubmit}>
          <input
            className="textfield"
            type="email"
            name="EMAIL"
            id="mce-EMAIL"
            placeholder="Your email"
            required
          />
          <input
            disabled={this.state.processing}
            className="submit"
            type="submit"
            value={this.state.processing ? 'Submitting' : 'Get Notified'}
          />
        </form>
        <iframe
          onLoad={this.urlChange}
          id={theId}
          name={theId}
          title="newsletter"
        />
      </div>
    )
  }
}
